import {
    Button,
    CardContent,
    Grid,
    IconButton,
    makeStyles,
    Modal,
    Paper,
    TextField,
    Typography
} from "@material-ui/core";
import React, { useContext } from "react";
import { Close } from "@material-ui/icons";
import * as Yup from "yup";
import { useFormik } from "formik";
import AppState from '../../context/AppContext';

const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: '360px',
        backgroundColor: 'white',
        color: 'black',
        '& .MuiFormHelperText-root': {
            color: 'black',
        },
        '& .Mui-error': {
            color: 'black',
        },
    },
    errorText: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    card: {
        marginTop: '20px',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        margin: 'auto',
        maxWidth: '420px',
        padding: theme.spacing(2),
    },
    typography: {
        marginTop: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardModal: {
        width: '100%',
    },
    closeButton: {
        float: 'right'
    },
}));

const EditChild = ( props ) => {
    const classes = useStyles();
    const auth = JSON.parse( sessionStorage.getItem( "user" ) );
    const context = useContext( AppState );
    const validationSchema = Yup.object().shape( {
        name: Yup.string().required( "Username is required" ),
        age: Yup.number().positive().integer().required( "Required" ),
    } );
    const child = context.store.children.find((child) => child.uid === props.uid);
    const name = child.name;
    const age = child.age;
    const handleClose = () => {
        props.handleClose();
        resetForm();
    };
    const onSubmit = ( values ) => {
        const index = context.store.children.findIndex(
            ( child ) => child.uid === props.uid
        );
        context.store.children[index] = {
            name: values.name,
            age: values.age,
            uid: props.uid,
            list: child.list
        }
        const data = {
            name: values.name,
            age: values.age,
            childUid: props.uid,
            list: child.list
        }
       context.updateChildDB( auth.user._id, props.uid, data ).then( ( data ) => {
          if(data){
              context.store.addEdit = false
              context.setStore( {
                  ...context.store,
              } );
          }
        } );
        handleClose();
    };
    const {
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        resetForm
    } = useFormik( {
        initialValues: {
            name: name || '',
            age: age || ''
        },
        validationSchema: validationSchema,
        onSubmit,
    } );
    return (
        <Modal open={props.open} className={classes.modal}>
            <Paper className={classes.paper}>
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <Close/>
                </IconButton>
                <Paper className={classes.card}>
                    <Typography variant="h5">Edit Child</Typography>
                    <CardContent>
                        <form onSubmit={handleSubmit} autoComplete="off" className={classes.form}>
                            <TextField
                                name="name"
                                defaultValue={name}
                                onChange={handleChange}
                                id="name"
                                label="User Name"
                                type="text"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="Enter name for your child"
                                onBlur={handleBlur}
                                className={classes.input}
                                error={!!(touched.name && errors.name)}
                                helperText={touched.name && errors.name ? errors.name : null}
                            />
                            <TextField
                                name="age"
                                defaultValue={age}
                                onChange={handleChange}
                                id="age"
                                label="Age"
                                type="number"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="Enter age for your child"
                                onBlur={handleBlur}
                                className={classes.input}
                                error={!!(touched.age && errors.age)}
                                helperText={touched.age && errors.age ? errors.age : null}
                            />
                            <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" onClick={handleClose}>
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Paper>
            </Paper>
        </Modal>
    );
};

export default EditChild;
